module.exports = __webpack_public_path__ + "img/xx.4c3922fb.jpg";